import { omit } from 'lodash-es';
import { getAllCountryCodesByRegions } from '@intelligence/v3/utils/region';
import { DataMethod } from '@intelligence/v3/enums/download';
import { DOWNLOAD_CFG_KEY } from '@intelligence/v3/constants';
import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';

const groupByGenerators = [
  {
    formModelKey: DOWNLOAD_CFG_KEY.REGION_METHOD,
    groupByKey: 'region',
    condition: (payload: string) => payload === 'region',
  },
  {
    formModelKey: DOWNLOAD_CFG_KEY.REGION_METHOD,
    groupByKey: 'market',
    condition: (payload: string) => payload === 'market',
  },
  {
    formModelKey: DOWNLOAD_CFG_KEY.DATE_METHOD,
    groupByKey: 'date',
    condition: (payload: string) => payload !== 'aggregated',
  },
  {
    formModelKey: DOWNLOAD_CFG_KEY.GENRE_METHOD,
    groupByKey: 'genre',
    condition: (payload: string) => payload === 'parentGenre',
  },
  {
    formModelKey: DOWNLOAD_CFG_KEY.GENRE_METHOD,
    groupByKey: 'sub_genre',
    condition: (payload: string) => payload === 'subGenre',
  },
];

const groupByFormModelKeys = groupByGenerators.map((generator) => generator?.formModelKey);

const getFileName = (params: any) => {
  const startDate = params?.start_date || '';
  const endDate = params?.end_date || '';
  const newStyleDownloadFileName = params?.new_style_donwload_file_name || '';
  if (!!startDate && !!endDate) {
    return `${newStyleDownloadFileName}_${startDate}_${endDate}`;
  }
  return `${newStyleDownloadFileName}`;
};

/**
 * 获取下载的markets入参
 * @param params 参数对象
 * @return 下载入参的国家列表
 */
const getDownloadMarkets = (params?: IRecord): string[] => {
  const markets = params?.markets || [];
  // @ts-ignore
  const dataMethod = params?.[DOWNLOAD_CFG_KEY.DATA_METHOD];
  if (dataMethod !== DataMethod.SelectTop) return markets;

  const marketsTmp =
    Array.isArray(markets) && markets.length > 0 ? markets : getAllCountryCodesByRegions(params?.regionOptions);
  return marketsTmp.slice(0, params?.[DOWNLOAD_CFG_KEY.SELECT_TOP]);
};

const getDownloadApiParams = <T extends IGenreMarketProfileFetchParams & IRecord = any>(params: T): T => {
  if (!params) return {} as unknown as T;

  const groupBys = (() => {
    const groupBys: string[] = [];

    groupByGenerators.forEach((generator) => {
      const formModelKey = generator?.formModelKey;
      const groupByKey = generator?.groupByKey;
      const condition = generator?.condition;
      if (!!condition?.(params?.[formModelKey])) {
        groupBys.push(groupByKey);
      }
    });

    return groupBys;
  })();

  const orderBys = (() => {
    if (groupBys.length === 0) return [];
    return groupBys.map((groupBy) => `${groupBy} desc`);
  })();

  const useMarketInfo = (() => {
    if (params?.[DOWNLOAD_CFG_KEY.REGION_METHOD] === 'market') {
      return ['market -> region', 'market -> en', 'market -> cn', 'intel_region -> en', 'intel_region -> cn'];
    }

    if (params?.[DOWNLOAD_CFG_KEY.REGION_METHOD] === 'region') {
      return ['intel_region -> en', 'intel_region -> cn'];
    }

    return [];
  })();

  return {
    ...omit(params, [
      ...groupByFormModelKeys,
      DOWNLOAD_CFG_KEY.DATA_METHOD,
      DOWNLOAD_CFG_KEY.SELECT_TOP,
      'data_amount',
      'file_format',
      'file_name',
      'metric',
      'new_style_donwload_file_name',
      'ratio',
      'regionOptions',
    ]),
    markets: getDownloadMarkets(params),
    metrics: params?.metric || [],
    entity_type: params?.entity_type || 'combine',
    filter: omit(params?.filter || {}, 'game_count'),
    group_by: groupBys,
    order_by: orderBys,
    use_market_info: useMarketInfo,
    page_size: 99999,
  } as unknown as T;
};
export default (params: IGenreMarketProfileFetchParams & IRecord) => {

  return {
    ...commonSetting,
    downloadMode: 'commonConf',
    downloadConfigKey: 'marketProfileTopChartsCombine',
    downloadFetchApi: '/api/v1/intelligence_pc/profile/market/metric_list',
    downloadApiParams: getDownloadApiParams(params),
    isUsingNewMethod: false,
    fetchOnlyOnce: true,
    dataKey: undefined,
    $$fileName: getFileName(params),
    regionOptions: params?.regionOptions,
  };
};
